import { render, staticRenderFns } from "./ns-orders-refund-product-popup.vue?vue&type=template&id=bf7eb098&"
import script from "./ns-orders-refund-product-popup.vue?vue&type=script&lang=js&"
export * from "./ns-orders-refund-product-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports